<template>
  <div class="fillIn">
    <div class="fillInContent">
      <div class="addCity">
        <div class="setwidth">{{tripData.qh_start_place}}</div>
        <p class="setwidth setwidthe"><img :src="require('../../assets/img/approval/jt.png')" /></p>
        <div class="setwidth">{{tripData.qh_end_place}}</div>
      </div>
      <div class="addDate">
        <div>
          <span>开始日期</span>
          <div class="setdatawidht">
            {{tripData.bgn_dt}}</div>
        </div>
        <div>
          <span>出差天数</span><br />
          <div class="day">
            <span>{{tripData.qh_total_days}}天</span>
          </div>
        </div>
        <div>
          <span>结束日期</span>
          <div class="setdatawidht">
            {{tripData.end_dt}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ax-trip',
  props: {
    tripData: {
      type: Object,
      default: {}
    },
  },
};
</script>
<style lang="scss" scoped>
.fillIn {
  padding: 16px 8px;
}

.fillInContent {
  /* min-height: 125px; */
  background: #fff;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 10px;
}

.addCity {
  display: flex;
  border-bottom: 1px dashed #dee3e9;
  color: #B0BBCA;
  font-size: 18px;
  font-weight: 500;
}
.addCity b{
  font-weight: 500;
}

.setwidth {
  flex: 1;
}

.addCity>div,
.addCity>p {
  height: 40px;
}

.addCity>:nth-child(3) {
  text-align: right;
}

.setwidthe {
  text-align: center;
}

.setwidthe img {
  width: 20%;
  display: inline-block;
}

.addlists {
  width: 100%;
  height: 86px;
  position: absolute;
  bottom: 0;
}

.addlists span {
  width: 100%;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  background: #3873FA;
  color: #fff;
  border-radius: 8px;
  margin-top: 12px;
  cursor: pointer;
  text-align: center;
}

.addDate {
  display: flex;
}

.addDate div {
  flex: 1;
  text-align: left;
  color: #B0BBCA;
  line-height: 21px;
  font-weight: 500;
}
.addDate div .setcolor{
   color: #637387;
}
.addDate div  b{
  font-weight: 500;
}
.addDate div span {
  display: inline-block;
  margin: 15px 0 3px 0;
}

.addDate>div:nth-child(3),
.addDate>div:nth-child(3) .setdatawidht {
  text-align: right;
}

.addDate>div:nth-child(2) {
  text-align: center;
}

.addDate>div:nth-child(2) .day {
  text-align: center;
}

.addDate>div:nth-child(2) .day span {
  min-width: 25px;
  display: inline-block;
  background: rgba(56, 115, 250, 0.05);
  color: #3873FA;
  border-radius:20px;
  padding: 0px 5px;
  font-size: 12px;
  text-align: center;
  margin: 0;
}

.trip {
  text-align: center;
  color: #3873FA;
  margin-top: 10px;
 
}
.trip img{
  width: 15px;
  display: inline-block;
  vertical-align: bottom;
  position: relative;
  top:0px;
  margin-right: 4px;
  // margin-top: 5px;
}
.setdatawidht {
  padding: 2px 0;
  font-size: 16px;
}
.addDate div .setcoloese{
  color:#1B2532;
  padding: 2px 0;
  font-size: 16px;
}
.setco{
  color:#1B2532;
}
.xiala h3 {
  text-align: center;
  font-size: 16px;
  line-height: 50px;
  color: #222;
}

.xiala .bao {
  width: 90%;
  height: 350px;
  margin: 0 auto;
  /* background: #3873FA; */
  overflow: auto;
}
.xiala .bao li{
  font-size:16px;
  color:#1B2532;
}
.disableds {
  pointer-events: none;
  color: #DEE3E9;;
}
.addDate .disableds .day span{
  background: #F7F8F9;
  color: #DEE3E9;;
}
.addDate .disableds {
  pointer-events: none;
  color: #DEE3E9;;
}
.addDate > div.disableds .day span{
  color: #DEE3E9;;
  background: #F7F8F9;
}
.disableds .setco,.addDate .disableds .setcoloese,.addDate div span.disableds {
    color: #DEE3E9;;
}

</style>